// import $ from 'jquery';
import TemplateView from 'picnic/core/views/Template';
import Template from 'app/cms/carcompanylist/views/ShowMoreCompany.html';


const
	CLASS_OPEN = 'is-open',
	SELECTOR_TOGGLE = '.show-more-company'
;


class View extends TemplateView {

	get isOpen() {
		return this.$el.hasClass(CLASS_OPEN);
	}

	set isOpen(value) {
		const
			$el = this.$el.find(SELECTOR_TOGGLE),
			text = $el.text()
		;

		this.$el.toggleClass(CLASS_OPEN, value);
		$el.text($el.data('toggle-text')).data('toggle-text', text);
	}

	get template() {
		return Template;
	}

	events() {
		return {
			'click .show-more-company': '_onClick'
		};
	}

	_onClick(event) {
		event.preventDefault();
		this.isOpen = !this.isOpen;
	}

}

export default View;
